module.exports = __webpack_public_path__ + "img/passAudit.320d3fb5.png";